import { render } from "./PlanCard.vue?vue&type=template&id=62ae5c11&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"

import "./PlanCard.vue?vue&type=style&index=0&id=62ae5c11&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ae5c11"]])

export default __exports__